import React from 'react'
import { Container, TituloSessao, BoxDepoimento, BoxDepoimentoFoto, BoxDepoimentoTexto, BoxDepoimentoNome, BoxDepoimentoLegenda } from './Styled'
import imagemYan from 'images/promocao-tj-sp-2025/yan-lacerda.png'
import imagemLigia from 'images/promocao-tj-sp-2025/ligia-kobayashi.png'

export default function BannerPrincipal () {

	return (
		<Container>

			{/* Título */}
			<TituloSessao>Veja só o que alguns de nossos alunos têm a dizer<br /> sobre ferramentas da Premium:</TituloSessao>

			{/* Item Depoimento */}
			<BoxDepoimento>

				{/* Foto */}
				<BoxDepoimentoFoto src={imagemYan} />

				{/* Texto */}
				<BoxDepoimentoTexto>“Utilizei de tudo: o Passo Estratégico, a Trilha Estratégica, o Sistema de Questões, os simulados<br /> que o Estratégia fornece. Era muito bom pra saber se eu estava no caminho certo.<br /> Só não passa quem desiste.”</BoxDepoimentoTexto>

				{/* Nome */}
				<BoxDepoimentoNome>Yan Lacerda</BoxDepoimentoNome>

				{/* Legenda */}
				<BoxDepoimentoLegenda>1º lugar TJ AP (Oficial de Justiça)</BoxDepoimentoLegenda>

			</BoxDepoimento>

			{/* Item Depoimento */}
			<BoxDepoimento>

				{/* Foto */}
				<BoxDepoimentoFoto src={imagemLigia} />

				{/* Texto */}
				<BoxDepoimentoTexto>“O Passo Estratégico me ajudou demais a revisar as matérias mais importantes. As aulas em áudio<br /> também foram muito úteis para eu ganhar tempo enquanto fazia as tarefas domésticas”.</BoxDepoimentoTexto>

				{/* Nome */}
				<BoxDepoimentoNome>Lígia Kobayashi</BoxDepoimentoNome>

				{/* Legenda */}
				<BoxDepoimentoLegenda>1º lugar no Banco do Brasil (microrregião 90)</BoxDepoimentoLegenda>

			</BoxDepoimento>

		</Container>
	)
}
